var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"value":_vm.value,"items":_vm.userStatusOptions,"label":"Employment status"},on:{"change":function($event){_vm.$emit('input', $event); _vm.$emit('change')}}})}
var staticRenderFns = []

export { render, staticRenderFns }